var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu',{on:{"mouseleave":_vm.onMouseLeave}},[_c('media',{attrs:{"query":{minWidth: 1200}},on:{"media-enter":function($event){_vm.isMobile = false},"media-leave":function($event){_vm.isMobile = true}}}),_vm._v(" "),(_vm.isMobile)?_vm._t("toggle",null,{"toggleEvents":_vm.toggleEvents,"isOpen":_vm.isOpen}):_vm._e(),_vm._v(" "),(!_vm.isMobile || _vm.isOpen)?[_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133fd562","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/MainMenu.vue
// module id = 68
// module chunks = 2